import * as React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import ModalStore from '../../../../../../../Modal/Store';
import { Succeeded } from '../../Store/Types';
import { T } from '../../../../../../../../Translations';

interface Props {
  modalStore: ModalStore;
  state: Succeeded;
}

const Content: React.FC<Props> = ({ modalStore, state }) => (
  <>
    <div className="mt-4 text-center">
      <T
        kind="{{successCount}} of {{totalCount}} participants were added..."
        successCount={state.bulkGroupMembershipsResource.payload.successCount}
        totalCount={state.bulkGroupMembershipsResource.payload.attemptedCount}
        groupName={state.bulkGroupMembershipsResource.payload.groupName}
      />
    </div>
    <div
      className={clsx(
        'rounded-md cursor-pointer bg-teal-600 text-white px-3 py-2 text-sm w-1/2 text-center mt-20 mb-16 mx-auto',
      )}
      onClick={modalStore.close}
    >
      <T kind="Done" />
    </div>
  </>
);

export default observer(Content);
